<template lang='pug'>
#detail.background(:style="backgroundStyle")
  .container.col(v-if="this.loadingStatus === 'completed'")
    header {{$t('offerTitle')}}
    .detail_info
      table.detail_table(
        :class="detailTitleClass"
      )
        tr(v-for="(item, id) in detailTitle")
          th.detail_title(v-if="id === 6 || id === 8") {{ $t(item, { currency }) }}
          th.detail_title(v-else) {{ $t(item) }}
          td.detail_content(
            v-if="id === 5"
          )
            .content_item(v-for="detail in contentTitle")
              .text {{ $t(detail) }} :
              | {{ detailObj[detail] }}
          td.detail_content(
            v-else-if="id === 4"
          ) {{ transKey(detailObj[item]) }}
          td.detail_content(
            v-else
            :class="textColor(id)"
          ) {{ detailObj[item] }}

  header.warning(v-if="this.loadingStatus === 'fail'") {{$t('noData')}}
</template>

<script>
/* eslint-disable camelcase */
import tableHead from './scripts/tableHead'
import BaseBall from '@/components/BaseBall'
import BaseImg from '@/components/BaseImg'
import translator from '@/utils/translator'

const url = new URLSearchParams(window.location.search)

export default {
  name: 'OffersDetailPage',
  components: {
    BaseBall,
    BaseImg
  },
  mixins: [translator],
  data () {
    return {
      tableHead,
      account: '',
      parentAccount: '',
      gameName: '',
      orderId: '',
      createdTime: Number,
      status: Number,
      transl: '',
      betInfo: {},
      multiples: Number,
      totalBetAmount: Number,
      totalWinAmount: Number,
      paidAt: Number,
      settledAt: Number,
      repaidAt: Number,
      gameRound: Number,
      result: {},
      gameId: '',
      gameCategory: '',
      gameLotto: '',
      profitType: Number,
      betProfit: 0,
      url: '',
      location: '',
      locale: 'en-us',
      token: '',

      loadingStatus: 'loading',

      // 東南亞獎號之位數
      prizeDigits: {
        VI27: {
          1: 5,
          2: 5,
          3: 5,
          4: 4,
          5: 4,
          6: 3,
          7: 2,
          sp: 5
        },
        VI18: {
          1: 5,
          2: 5,
          3: 5,
          4: 5,
          5: 4,
          6: 4,
          7: 3,
          8: 2,
          sp: 6
        },
        THAI: {
          1: 6,
          2: 3,
          3: 3,
          4: 2
        }
      },
      orderAgo: process.env.VUE_APP_ORDER_AGO,

      detailObj: {},
      currency: ''
    }
  },
  computed: {
    detailTitle () {
      const { statusValue } = this.detailObj
      const array = [
        'account',
        'draw_numbers',
        'event_id',
        'event_name',
        'cvent_categories',
        'event_information',
        'event_amount',
        'status',
        'paid_amount',
        'endTime',
        'remark'
      ]

      if (statusValue === 4) {
        array.splice(10, 0, 'cancellation_payout_time')
      }

      return array
    },
    contentTitle () {
      return [
        'game_name',
        'rounds_num',
        'shooting_num_no'
      ]
    },
    detailTitleClass () {
      const { statusValue } = this.detailObj

      return statusValue === 4 ? 'long' : 'short'
    },
    isWin () {
      const { statusValue } = this.detailObj

      return statusValue === 2
    },
    backgroundStyle () {
      return this.loadingStatus === 'fail' ? { 'height': '100vh' } : ''
    }
  },
  watch: {
    // 如果沒有Amend Time, tableHead中的AmendTime也不會出現
    repaidAt () {
      if (this.isAmendTimeShow) return
      const index = this.tableHead.tableTwo.indexOf('amendTime')
      this.table = this.tableHead.tableTwo.splice(index, 1)
    }
  },
  created () {
    if (process.env.VUE_APP_NETWORK_MAINTENANCE === 'on') this.getMaintainStatus()
  },
  mounted () {
    this.loadingStatus = 'loading'

    // 沒帶language參數就不判斷了，會直接帶入data預設的en-us
    const language = url.get('language')
    if (language) {
      switch (language.toLowerCase()) {
        case 'en-us':
        case 'en':
          this.locale = 'en-us'
          break

        default:
          this.locale = 'zh-cn'
          break
      }
    }
    // 用moment-timezone抓取客戶端時區
    // this.location = this.$_MOMENT.tz.guess().replace('/', '-')

    this.getDetail()
  },
  methods: {
    async getMaintainStatus () {
      const lang = url.get('language') || 'en-us'
      try {
        const params = {
          agent: url.get('agent'),
          general_agent: url.get('general_agent')
        }
        const res = await this.$_AXIOS.get(`${process.env.VUE_APP_MAINTAIN_API_URL}/internet/maintain/gc/list`, { params })
        const { data } = res.data

        if (data.maintain_status === 1) location.href = `${process.env.VUE_APP_FIX_PAGE_URL}/block/maintenance?lang=${lang}`
      } catch (error) {
        console.log(error)
        location.href = `${process.env.VUE_APP_FIX_PAGE_URL}/block/maintenance?lang=${lang}`
      }
    },
    getDetail () {
      const params = {
        preferential_id: url.get('preferential_record_id')
      }
      const headers = {
        locale: url.get('language')
      }
      this.$_AXIOS
        .get('/v2/ml/record/detail-preferential', {
          params,
          headers
        })
        .then(async res => {
          // 需要先判斷上層物件是否存在的資料
          // 這裏如果用if else判斷會過於冗贅, 因此還是使用三元運算子
          const ns = ['general', 'phase']
          await this.$i18n.i18next.reloadResources(null, ns)
          await this.$i18n.i18next.setDefaultNamespace(ns)

          let data = res.data.data
          // 如果detail不為空物件才繼續, 否則throw error
          if (Object.keys(data).length !== 0) {
            // 沒有包在detail中的資料
            const {
              user_account,
              preferential_record_id,
              preferential_event_name,
              status,
              preferential_correspond_config_key,
              preferential_event_id,
              preferential_paid_amount,
              paid_amount,
              paid_time,
              cancel_time,
              detail,
              game_name,
              game_round,
              is_correspond,
              currency
            } = data

            this.currency = currency

            this.detailObj = {
              account: user_account,
              draw_numbers: preferential_record_id,
              event_id: this.numAddZero(preferential_event_id),
              event_name: preferential_event_name,
              cvent_categories: preferential_correspond_config_key,
              event_amount: this.showDecimal(preferential_paid_amount),
              status: this.parseStatusText(status),
              statusValue: status,
              paid_amount: this.paidAmount(status, paid_amount),
              endTime: status === 3 || status === 1 ? '-' : this.getTime(paid_time),
              cancellation_payout_time: this.getTime(cancel_time),
              remark: is_correspond ? '' : this.$t('not_qualified'),
              game_name,
              rounds_num: game_round,
              shooting_num_no: this.numAddZero(detail.y_number)
            }

            return
          }
          throw new Error()
        })
        .catch(error => {
          console.log(error)
          this.loadingStatus = 'fail'
        })
        .then(() => {
          // 避免上面loadingStatus已經為fail又被改回來的情況
          if (this.loadingStatus === 'fail') return

          setTimeout(() => {
            this.loadingStatus = 'completed'
          }, 1000)
        })
    },
    parseStatusText (status) {
      const keys = {
        0: 'all',
        1: 'offers_processing',
        2: 'paid_out',
        3: 'canceled',
        4: 'disclaim'
      }
      return this.$t(keys[status]) || '-'
    },
    numAddZero (num) {
      const leng = num.toString().length
      return Array.from({ length: 5 - leng }, () => '0').join('') + num.toString()
    },
    paidAmount (status, paid_amount) {
      if (status === 1 || status === 3) return '-'
      if (status === 4) return '0.00'

      return this.showDecimal(paid_amount)
    },
    showDecimal (num, index = 2) {
      if (isNaN(num)) return num
      const newnum = num.toString()
      const snum = newnum.split('.')
      let buz = ''
      if (snum[1] === undefined) {
        buz = Array.from({ length: index }, () => '0').join('')
      } else {
        const arr = snum[1].split('')
        for (let i = 0; i < index; i++) {
          buz += arr[i] ? arr[i] : '0'
        }
      }
      return this.cFormat(snum[0] + '.' + buz)
    },
    cFormat (value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getTime (time) {
      return this.$_MOMENT.unix(time).format('YYYY-MM-DD HH:mm:ss')
    },
    transKey (key) {
      let groupNum = 1
      if (key === 3) groupNum = 16

      return this.$t('shooting_num_draw_group', { num: groupNum })
    },
    textColor (index) {
      return this.isWin && (index === 8 || index === 7) ? 'textColor' : ''
    }
  }
}
</script>
<style scoped lang='stylus' src='./OffersDetailPage.styl'>
